import React, { Component } from "react"
import { NavLink, Route } from "react-router-dom"
import glamorous from "glamorous"

import style from "utils/style"

class DocumentView extends Component {
  generateHeaderContent(route) {
    return () => (
      <HeaderContent>
        <HeaderTitle>{route.name}</HeaderTitle>
        <HeaderSubtitle>{route.subtitle}</HeaderSubtitle>
      </HeaderContent>
    )
  }

  render() {
    return (
      <div>
        <Header>
          {this.props.sections.map(section =>
            section.children.map((route, key) => (
              <Route
                key={key}
                exact
                path={route.route}
                component={this.generateHeaderContent(route)}
              />
            ))
          )}
        </Header>

        <BottomWrapper>
          <Sidebar>
            {this.props.sections.map((section, key) => (
              <Section key={key}>
                <SectionTitle>{section.name}</SectionTitle>
                <SectionList>
                  {section.children.map((child, key) => (
                    <StyledLink key={key} exact to={child.route}>
                      {child.name}
                    </StyledLink>
                  ))}
                </SectionList>
              </Section>
            ))}
          </Sidebar>

          <AboutContent id="#content">
            {this.props.sections.map(section =>
              section.children.map((route, key) => (
                <Route
                  key={key}
                  exact
                  path={route.route}
                  component={route.component}
                />
              ))
            )}
          </AboutContent>
        </BottomWrapper>
      </div>
    )
  }
}

const BottomWrapper = glamorous.div({
  display: "flex",
  maxWidth: 1200,
  margin: "0 auto",
  [style.size.mobile]: {
    flexDirection: "column",
  },
})

// CSS: Header, title

const Header = glamorous.div({
  padding: "48px 55px",
  background:
    "linear-gradient(to right, rgba(64,52,47,1) 0%, rgba(109,97,91,1) 100%)",
  color: "white",
  minWidth: "100%",
  [style.size.mobile]: {
    padding: "20px 30px",
  },
})

const HeaderContent = glamorous.div({
  maxWidth: 1200,
  margin: "0 auto",
})

const HeaderTitle = glamorous.h2({
  fontSize: "2.5rem",
  fontWeight: 100,
  [style.size.mobile]: {
    fontSize: "1.7rem",
  },
})

const HeaderSubtitle = glamorous.p({
  paddingTop: 10,
  fontStyle: "italic",
  color: style.colors.brown,
  [style.size.mobile]: {
    fontSize: "0.9rem",
  },
})

// CSS: Content wrapper

const AboutContent = glamorous.div({
  padding: 20,
  [style.size.mobile]: {
    paddingTop: 0,
  },
})

// CSS: Sidebar

const Sidebar = glamorous.div({
  padding: 20,
  width: 360,
  maxWidth: 360,
  minWidth: 360,
  [style.size.mobile]: {
    minWidth: "100%",
    width: "100%",
    maxWidth: "100%",
    paddingBottom: 0,
  },
})

const Section = glamorous.div({
  marginBottom: 15,
  paddingBottom: 15,
  borderBottom: `1px solid ${style.colors.darkerGray}`,
  [style.size.desktop]: {
    "&:last-child": {
      borderBottom: "none",
    },
  },
  [style.size.mobile]: {
    marginBottom: 13,
    paddingBottom: 7,
    "&:last-child": {
      marginBottom: 3,
    },
  },
})

const SectionTitle = glamorous.h3({
  fontSize: "1.75rem",
  fontWeight: "700",
  marginBottom: 12,
  paddingTop: 5,
  color: style.colors.almostBlack,
  [style.size.mobile]: {
    fontWeight: "700",
    fontSize: "0.85rem",
    textTransform: "uppercase",
    letterSpacing: 1.4,
  },
})

const SectionList = glamorous.ul({
  display: "flex",
  [style.size.desktop]: {
    flexDirection: "column",
    flexWrap: "nowrap",
  },
  [style.size.mobile]: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
})

const StyledLink = glamorous(NavLink)({
  fontWeight: 100,
  textDecoration: "none",
  color: style.colors.brown,
  display: "flex",
  borderRadius: 6,
  transition: "all 0.3s",
  [style.size.desktop]: {
    fontSize: "1.2rem",
    padding: "13px 18px",
    "&.active": {
      background:
        "linear-gradient(to right, rgba(227,222,220,1) 0%, rgba(196,192,190,1) 100%)",
      borderRadius: 6,
      color: style.colors.darkBrown,
    },
  },
  [style.size.mobile]: {
    width: "32%",
    backgroundColor: style.colors.veryLightGray,
    border: `1px solid ${style.colors.darkerGray}`,
    borderRadius: 8,
    padding: "8px 8px",
    marginBottom: 10,
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    fontWeight: 500,
    fontSize: "0.85rem",
    color: style.colors.darkBrown,
  },
})

export default DocumentView



// WEBPACK FOOTER //
// ./src/components/DocumentView/index.js